import React, { useState } from "react";
import "../../Assests/Scss/QuestionRating.scss";
import { FaAngleDoubleRight, FaAngleDoubleLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import axios from "axios";

import InternetChecking from "../../Reusablecomponents/Network";
import Dull from "../../Assests/Images/Dull.png";
import sad from "../../Assests/Images/sad.png";
import Neutral from "../../Assests/Images/Neutral.png";
import happy from "../../Assests/Images/happy.png";
import happiest from "../../Assests/Images/happiest.png";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import notify from "../../../ReusableComponents/ToastifyAlerts";
const QuestionRating = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  // const TesType = useSelector((state) => state.TesTypedata.TesType);
  const [RatingText, SetRatingText] = useState("Choose your experience");
  const [Rating, SetRating] = useState();
  const [Comment, SetComment] = useState();
  // const QRatingDetails = JSON.parse(localStorage.getItem("QRating"));

  const SelectRating = (e) => {
    switch (e) {
      case "Dull":
        SetRatingText("Worst");
        SetRating(1);
        break;
      case "Sad":
        SetRatingText("Bad");
        SetRating(2);
        break;
      case "Neutral":
        SetRatingText("Okay");
        SetRating(3);
        break;
      case "Happy":
        SetRatingText("Good");
        SetRating(4);
        break;
      case "Happiest":
        SetRatingText("Excellent");
        SetRating(5);
        break;

      default:
        SetRatingText("Choose your experience");
        SetRating();
        break;
    }
  };
  const FeedbackSubmit = async () => {
    if (Rating && Comment) {
      const setData = {
        questionId: location.state.QID,
        userId: items?.userId,
        contestCreationId: location.state.CCID,
        rate: Rating,
        questionComment: Comment,
        AssessmentType: location.state.TType,
      };

      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL +
          "/StudentResults/UpdateQuestionRateing",
          setData,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )

        .then((res) => {
          if (res.data === 1) {
            notify("Rating submitted successfully", "success");
            navigate(-1);
          } else {
            notify("Please provide the rating and comments to submit", "warning");
          }
        })
        .catch((err) => console.log(err));
    } else {
      notify(`Please provide the ${Rating ? "comments" : "rating"} to submit`, "warning");
    }
  };
  return (
    <>
      <div className="Instructions-pages QRating-Maindiv ">
        <InternetChecking />
        <div className="QRating-Main">Did you like this Question?</div>
        <div className="QRating-Body">
          <div className="Rating">
            <span>Please provide the rating for the selected Question</span>
            <div className="Smile dflex flexd-column alignitems">
              <div className="dflex">
                <div className="dflex flexd-column alignitems">
                  {" "}
                  <img
                    src={Dull}
                    alt="Dull"
                    className={Rating === 1 ? "SRating" : "NRating"}
                    onClick={() => SelectRating("Dull")}
                  />{" "}
                  {Rating === 1 && RatingText}
                </div>
                <div className="dflex flexd-column alignitems">
                  {" "}
                  <img
                    src={sad}
                    alt="Sad"
                    className={Rating === 2 ? "SRating" : "NRating"}
                    onClick={() => SelectRating("Sad")}
                  />
                  {Rating === 2 && RatingText}
                </div>
                <div className="dflex flexd-column alignitems">
                  {" "}
                  <img
                    src={Neutral}
                    alt="Neutral"
                    className={Rating === 3 ? "SRating" : "NRating"}
                    onClick={() => SelectRating("Neutral")}
                  />
                  {Rating === 3 && RatingText}
                </div>
                <div className="dflex flexd-column alignitems">
                  {" "}
                  <img
                    src={happy}
                    alt="Happy"
                    className={Rating === 4 ? "SRating" : "NRating"}
                    onClick={() => SelectRating("Happy")}
                  />
                  {Rating === 4 && RatingText}
                </div>
                <div className="dflex flexd-column alignitems">
                  {" "}
                  <img
                    src={happiest}
                    alt="Happiest"
                    className={Rating === 5 ? "SRating" : "NRating"}
                    onClick={() => SelectRating("Happiest")}
                  />
                  {Rating === 5 && RatingText}
                </div>
              </div>
              <span>{Rating === undefined && RatingText}</span>
            </div>
          </div>

          <div className="Comment">
            <h6>Comment</h6>
            <textarea
              placeholder="Enter comments up to 150 characters"
              rows="5"
              onChange={(e) => SetComment(e.target.value)}
            />
          </div>
          <div className="QRating-buttons alignitems dflex flexd-column">
            <button
              className="Buttons"
              onClick={() => navigate(-1)}
            >
              {" "}
              <FaAngleDoubleLeft /> Close
            </button>

            <button className="Buttons" onClick={FeedbackSubmit}>
              Submit
              <FaAngleDoubleRight />
            </button>
          </div>
        </div> 
      </div>
      {/* <CopyRight /> */}
    </>
  );
};
export default QuestionRating;
